























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';
import SwitchBox from '@/componentsV2/molecules/Inputs/SwitchBox.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import MegaphoneIcon from '@/components/icons/Megaphone.vue';
import UsersCustomerCenterIcon from '@/components/icons/UsersCustomerCenter.vue';
import CustomerCohortsService, {
  ICohortCounts
} from '@/api/CustomerCohortsService';
import HTTPStatus from '@/constants/httpStatus';
import {
  IAudienceSelection,
  LIFECYCLE_AUDIENCES,
  LifecycleAudience,
  everyoneSelection,
  isEmptySelection,
  isEveryone,
  statusDayRanges
} from '@/models/offerAudience';

@Component({
  components: {
    FormHeader,
    SwitchBox,
    SelectionBox,
    MegaphoneIcon,
    UsersCustomerCenterIcon
  }
})
export default class Audience extends Vue {
  @Prop() selection!: IAudienceSelection;
  @Prop({ default: false }) locked!: boolean;
  @Prop({ default: false }) hasError!: boolean;
  @Prop({ default: 30 }) windowDays!: number;

  counts: Record<string, number> = {};
  // The counts only decorate the cards: a failed lookup hides them instead of raising a toast.
  cohortsService = new CustomerCohortsService({ disableToastMessage: true });

  get tPrefix() {
    return 'offers.form.audience';
  }

  get statuses() {
    return LIFECYCLE_AUDIENCES;
  }

  get everyone() {
    return isEveryone(this.selection);
  }

  mounted() {
    if (!this.locked) this.loadCounts();
  }

  async loadCounts() {
    const { status, data } = await this.cohortsService.getCounts('lifecycle');
    if (status !== HTTPStatus.OK || !data) return;
    this.counts = ((data as ICohortCounts).values || []).reduce(
      (acc, { value, customers }) => ({ ...acc, [value]: customers }),
      {}
    );
  }

  isSelected(status: LifecycleAudience) {
    return this.selection.statuses.includes(status);
  }

  countLabel(status: LifecycleAudience) {
    if (!(status in this.counts)) return undefined;
    return this.$tc(`${this.tPrefix}.members`, this.counts[status], {
      count: this.counts[status].toLocaleString('en-US')
    });
  }

  statusDescription(status: LifecycleAudience) {
    return this.$t(
      `${this.tPrefix}.statuses.${status}.description`,
      statusDayRanges(this.windowDays)
    );
  }

  onEveryoneToggle(on: boolean) {
    this.emitSelection(
      on ? everyoneSelection() : { statuses: [], nonMembers: false }
    );
  }

  toggleStatus(status: LifecycleAudience, checked: boolean) {
    const statuses = checked
      ? LIFECYCLE_AUDIENCES.filter(
          each => each === status || this.selection.statuses.includes(each)
        )
      : this.selection.statuses.filter(each => each !== status);
    this.emitSelection({ ...this.selection, statuses });
  }

  toggleNonMembers(checked: boolean) {
    this.emitSelection({ ...this.selection, nonMembers: !!checked });
  }

  emitSelection(selection: IAudienceSelection) {
    this.$emit('input', selection);
    if (!isEmptySelection(selection))
      this.$emit('clearError', 'offer-audience');
  }
}
